import preferencesManager from './updatePropertySelection';

const holder = {
  closePropertySelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.outlet({ selectedPropertyIds: holder.selectedPropertyIds, selectedGroupIds: holder.selectedGroupIds });

      window.adminPreferences.selected_group_ids = holder.selectedGroupIds;
      window.adminPreferences.selected_property_ids = holder.selectedPropertyIds;
      !holder.silentUpdate && preferencesManager.saveAdminPreference({ selected_group_ids: holder.selectedGroupIds, selected_property_ids: holder.selectedPropertyIds });

      holder.internalStateSetter('isOpen', false);
      document.removeEventListener("mousedown", holder.closePropertySelector)
    }
  }
};

export default {
  'MultiPropertySelector.Selector': async ({ isOpen, containerRef, isReadonly, inputRef, selectedPropertyIds, selectedGroupIds, silentUpdate }, outlet, internalStateSetter) => {
    if (isReadonly) return;
    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = containerRef;
    holder.outlet = outlet;
    holder.silentUpdate = silentUpdate;
    holder.selectedPropertyIds = selectedPropertyIds;
    holder.selectedGroupIds = selectedGroupIds;
    await internalStateSetter('isOpen', !isOpen);

    inputRef?.current?.children?.[0]?.children?.[0]?.focus?.()

    if (isOpen) {
      document.removeEventListener("mousedown", holder.closePropertySelector);
    } else {
      document.addEventListener("mousedown", holder.closePropertySelector);
    }
  },
  'MultiPropertySelector.Body.SearchWrapper.Search': ({ value }, _, internalStateSetter) => {
    const matched = value.match(/[A-Za-z0-9\s]+/g)
    if (matched?.length > 0) {
      internalStateSetter('searchTerm', matched.shift())
    }
    else {
      internalStateSetter('searchTerm', "")
    }
  },
  'MultiPropertySelector.Body.Properties.Property': ({ id, selectedPropertyIds, selectedGroupIds }, _, internalStateSetter) => {
    const newSelectedPropertyIds = [...selectedPropertyIds];
    if (newSelectedPropertyIds.includes(id)) {
      const index = newSelectedPropertyIds.indexOf(id);
      newSelectedPropertyIds.splice(index, 1)
    } else {
      newSelectedPropertyIds.push(id);
    }

    internalStateSetter({ selectedPropertyIds: newSelectedPropertyIds, selectedGroupIds });
    holder.selectedPropertyIds = newSelectedPropertyIds;
    holder.selectedGroupIds = selectedGroupIds;
  },
  'MultiPropertySelector.Body.Properties.Group': ({ id, selectedGroupIds, selectedPropertyIds }, _, internalStateSetter) => {
    const newSelectedGroupIds = [...selectedGroupIds];
    if (newSelectedGroupIds.includes(id)) {
      const index = newSelectedGroupIds.indexOf(id);
      newSelectedGroupIds.splice(index, 1)
    } else {
      newSelectedGroupIds.push(id);
    }

    internalStateSetter({ selectedPropertyIds, selectedGroupIds: newSelectedGroupIds });
    holder.selectedPropertyIds = selectedPropertyIds;
    holder.selectedGroupIds = newSelectedGroupIds;

  },
  'MultiPropertySelector.Selector.LeftSide.ButtonList.PropertyButton': ({ id, selectedPropertyIds, selectedGroupIds, isReadonly, silentUpdate }, outlet) => {
    if (isReadonly) return;
    const newSelectedPropertyIds = [...selectedPropertyIds];
    const index = newSelectedPropertyIds.indexOf(id);
    newSelectedPropertyIds.splice(index, 1);
    outlet({ selectedPropertyIds: newSelectedPropertyIds, selectedGroupIds });

    if (window.adminPreferences)
      window.adminPreferences.selected_property_ids = newSelectedPropertyIds;
    !silentUpdate && preferencesManager.saveAdminPreference({ selected_property_ids: newSelectedPropertyIds });
  },
  'MultiPropertySelector.Selector.LeftSide.ButtonList.GroupButton': ({ id, selectedGroupIds, selectedPropertyIds, silentUpdate }, outlet) => {
    const newSelectedGroupIds = [...selectedGroupIds];
    const index = newSelectedGroupIds.indexOf(id);
    newSelectedGroupIds.splice(index, 1);
    outlet({ selectedGroupIds: newSelectedGroupIds, selectedPropertyIds });

    if (window.adminPreferences)
      window.adminPreferences.selected_group_ids = newSelectedGroupIds;
    !silentUpdate && preferencesManager.saveAdminPreference({ selected_group_ids: newSelectedGroupIds });
  },
  'MultiPropertySelector.Body.ClearAllHeader': ({ selectedPropertyIds, properties }, _, internalStateSetter) => {
    if (selectedPropertyIds.length > 0) {
      internalStateSetter({ selectedGroupIds: [], selectedPropertyIds: [] });
      holder.selectedPropertyIds = [];
      holder.selectedGroupIds = [];
    } else {
      internalStateSetter({ selectedGroupIds: [], selectedPropertyIds: properties.map(property => property.id) })

      holder.selectedPropertyIds = properties.map(property => property.id);
      holder.selectedGroupIds = [];
    }
  },
};
